import { Farm, ServiceType } from "@agroyaar/sdk";
import { FieldMarkerIcon } from "../../../../../../components/map/utils/customs";
import AgroMapFarm from "../../../../../../features/map/presentation/components/AgroMapFarm";
import { toolbarBaseControls } from "../../../../../../features/map/utils/configs";
import { reportColor } from "../../../utils/report-color";

interface FarmInformationProps {
  farm: Farm;
  serviceType: ServiceType;
}

const FarmInformation = ({ farm, serviceType }: FarmInformationProps) => {
  const colorCode = reportColor(serviceType);

  return (
    <div className="flex flex-col justify-center items-start w-1/2 gap-2">
      <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
        اطلاعات زمین
      </span>

      <div className="flex flex-row justify-start items-center gap-[19px] w-full">
        <div
          className="relative overflow-hidden  rounded-full w-[80px] h-[80px]"
          style={{ border: `2px solid ${colorCode}` }}
        >
          <div className="THISISFORMAPLOCK! bg-transparent z-[99999999] w-full h-full absolute"></div>
          <AgroMapFarm
            mapId={farm.id}
            type="onlyShow"
            // @ts-ignore
            toolbarOptions={toolbarBaseControls}
            markerIcon={FieldMarkerIcon}
            currentFarmPolygon={farm.polygon}
          />
        </div>
        <div className="flex flex-col justify-center items-start gap-[6px] font-bold text-[16px]">
          <div className="flex flex-row items-start gap-[8px]">
            <span className="text-[18px] font-bold !font-[B-Nazanin]">
              نام قطعه:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {farm.name}
            </span>
          </div>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="text-[18px] font-bold !font-[B-Nazanin]">
              مساحت:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {farm.area} هکتار
            </span>
          </div>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="text-[18px] font-bold !font-[B-Nazanin]">
              استان و شهر:
            </span>
            <span className="text-[16px] font-bold !font-[B-Nazanin]">
              {farm.province.name}، {farm.city.name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmInformation;
